module.exports = __webpack_public_path__ + "8ad9c2a7b7820868e1e9bf87df3448aa.MP3";